import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline  = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online",  goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online",  goOnline);
    };
  }, []);

  return (
    <Collapse in={offline}>
      <Alert
        severity="warning"
        icon={<WifiOffIcon fontSize="inherit" />}
        sx={{ borderRadius: 0, py: 0.5 }}
      >
        You're offline — messages may be delayed until your connection is restored.
      </Alert>
    </Collapse>
  );
};

export default OfflineBanner;
